import { ReactElement } from 'react';
import { colors } from '~/styles/colors';

type XCloseIconProps = {
  color?: string;
  size?: string
}

export const XCloseIcon = ({ size = '24', color = colors.icon['white-0'] }: XCloseIconProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
